import React from "react";
//material
import Typography from "@material-ui/core/Typography";
import Backdrop from "@material-ui/core/Backdrop";
// import Skeleton from "@material-ui/lab/Skeleton";
import ListItem from "@material-ui/core/ListItem";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import ListItemText from "@material-ui/core/ListItemText";
import AttachMoneyIcon from "@material-ui/icons/AttachMoney";
import ListItemSecondaryAction from "@material-ui/core/ListItemSecondaryAction";
import Divider from "@material-ui/core/Divider";
import IconButton from "@material-ui/core/IconButton";
import VisibilityIcon from "@material-ui/icons/Visibility";
//utilst
import currency from "../../../utils/currency";
import { date } from "../../../utils/dateTime";

import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  backdrop: {
    zIndex: theme.zIndex.drawer + 1,
    color: "#fff",
  },
  liquidSecond: {
    fontSize: 14,
    color: theme.palette.textColor.gray,
  },
  liquidPrimary: {
    fontSize: 14,
  },
  liquidSecondList: {
    maxWidth: "200px",
    fontSize: 12,
    color: theme.palette.textColor.gray,
  },
  liquidThird: {
    fontSize: 12,
    color: theme.palette.primary.main,
  },
  img: {
    width: "100%",
    backgroundRepeat: "no-repeat",
    backgroundSize: "cover",
    backgroundPosition: "top",
    "@media(min-width: 280px)": {
      height: 128,
    },
    "@media(min-width: 320px)": {
      height: 148,
    },
    "@media(min-width: 360px)": {
      height: 168,
    },
    "@media(min-width: 960px)": {
      height: 270,
    },
  },
  wrapper: {
    display: "flex",
    alignItems: "center",
    paddingLeft: 4,
    paddingRight: 4,
    marginBottom: 15,
    "@media(min-width: 280px)": {
      width: "calc(100%/2)",
      height: "100%",
    },
    "@media(min-width: 320px)": {
      width: "calc(100%/2)",
      height: "100%",
    },
    "@media(min-width: 360px)": {
      width: "calc(100%/2)",
      height: "100%",
    },
    "@media(min-width: 400px)": {
      width: "calc(100%/2)",
      height: "100%",
    },
    "@media(min-width: 600px)": {
      width: "calc(100%/3)",
      height: "100%",
    },
    "@media(min-width: 960px)": {
      width: "calc(100%/4)",
      height: "100%",
    },
  },
}));

function ListItemMap({ data }) {
  const classes = useStyles();

  const {
    id,
    tujuan_bank: { nama_bank },
    created_at,
    total_pencairan,
    bukti_transfer_permbayaran,
    status,
  } = data;

  const [open, setOpen] = React.useState(false);

  const handleClose = () => {
    setOpen(false);
  };

  const handleToggle = () => {
    setOpen(!open);
  };
  let appro = data.status == "approved";
  const tampilan = appro ? data.status : null;

  return (
    <>
      <ListItem button>
        <ListItemIcon>
          <AttachMoneyIcon color="primary" />
        </ListItemIcon>
        <ListItemText
          primary={
            <Typography className={classes.liquidPrimary}>Pencairan</Typography>
          }
          secondary={
            <div>
              <Typography className={classes.liquidSecondList}>
                #{id} via {nama_bank}{" "}
              </Typography>

              <Typography className={classes.liquidSecondList}>
                {created_at && date(created_at.toDate())}
              </Typography>
            </div>
          }
        />
        <ListItemSecondaryAction>
          <Typography className={classes.liquidThird}>
            {currency(total_pencairan)}
          </Typography>
          <Typography
            style={
              status === "approved" || status === "paid"
                ? { color: "#5675D3" }
                : status === "rejected" || status === "failed"
                ? { color: "red" }
                : { color: "orange" }
            }
            className={classes.liquidSecondList}
          >
            {status}
          </Typography>
          {tampilan ? (
            <IconButton edge="end" size="small" onClick={handleToggle}>
              <VisibilityIcon color="primary" />
            </IconButton>
          ) : null}
        </ListItemSecondaryAction>
      </ListItem>
      <Divider />
      <Backdrop className={classes.backdrop} open={open} onClick={handleClose}>
        <div className={classes.wrapper}>
          <img
            loading="lazy"
            src={bukti_transfer_permbayaran}
            alt="bukti"
            className={classes.img}
            // style={{
            //   backgroundImage: `url(${data.thumbnail[0]})`,
            // }}
          />
        </div>
      </Backdrop>
    </>
  );
}

export default ListItemMap;
